<template>
  <div class="main-panel">
    <div class="filter">
      <transition name="fade" mode="out-in">
        <h2 v-if="!showFilter" @click="showFilter = !showFilter">
          <svg
            width="20"
            height="20"
            viewBox="0 0 20 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M6.80841 15C6.98058 14.512 7.29986 14.0895 7.72225 13.7906C8.14463 13.4918 8.64932 13.3313 9.16675 13.3313C9.68418 13.3313 10.1889 13.4918 10.6112 13.7906C11.0336 14.0895 11.3529 14.512 11.5251 15H17.5001C17.9603 15 18.3334 15.3731 18.3334 15.8333C18.3334 16.2936 17.9603 16.6667 17.5001 16.6667H11.5251C11.3529 17.1546 11.0336 17.5771 10.6112 17.876C10.1889 18.1749 9.68418 18.3354 9.16675 18.3354C8.64932 18.3354 8.14463 18.1749 7.72225 17.876C7.29986 17.5771 6.98058 17.1546 6.80841 16.6667H2.50008C2.03984 16.6667 1.66675 16.2936 1.66675 15.8333C1.66675 15.3731 2.03984 15 2.50008 15H6.80841ZM11.8084 9.16665C11.9806 8.67871 12.2999 8.25618 12.7222 7.95731C13.1446 7.65844 13.6493 7.49794 14.1667 7.49794C14.6842 7.49794 15.1889 7.65844 15.6112 7.95731C16.0336 8.25618 16.3529 8.67871 16.5251 9.16665H17.5001C17.9603 9.16665 18.3334 9.53975 18.3334 9.99999C18.3334 10.4602 17.9603 10.8333 17.5001 10.8333H16.5251C16.3529 11.3213 16.0336 11.7438 15.6112 12.0427C15.1889 12.3415 14.6842 12.502 14.1667 12.502C13.6493 12.502 13.1446 12.3415 12.7222 12.0427C12.2999 11.7438 11.9806 11.3213 11.8084 10.8333H2.50008C2.03984 10.8333 1.66675 10.4602 1.66675 9.99999C1.66675 9.53975 2.03984 9.16665 2.50008 9.16665H11.8084ZM3.47508 3.33332C3.64725 2.84538 3.96653 2.42285 4.38891 2.12398C4.8113 1.82511 5.31599 1.66461 5.83342 1.66461C6.35084 1.66461 6.85553 1.82511 7.27792 2.12398C7.7003 2.42285 8.01958 2.84538 8.19175 3.33332H17.5001C17.9603 3.33332 18.3334 3.70642 18.3334 4.16665C18.3334 4.62689 17.9603 4.99999 17.5001 4.99999H8.19175C8.01958 5.48793 7.7003 5.91046 7.27792 6.20933C6.85553 6.5082 6.35084 6.6687 5.83342 6.6687C5.31599 6.6687 4.8113 6.5082 4.38891 6.20933C3.96653 5.91046 3.64725 5.48793 3.47508 4.99999H2.50008C2.03984 4.99999 1.66675 4.62689 1.66675 4.16665C1.66675 3.70642 2.03984 3.33332 2.50008 3.33332H3.47508ZM5.83342 4.99999C6.05443 4.99999 6.26639 4.91219 6.42267 4.75591C6.57895 4.59963 6.66675 4.38767 6.66675 4.16665C6.66675 3.94564 6.57895 3.73368 6.42267 3.5774C6.26639 3.42112 6.05443 3.33332 5.83342 3.33332C5.6124 3.33332 5.40044 3.42112 5.24416 3.5774C5.08788 3.73368 5.00008 3.94564 5.00008 4.16665C5.00008 4.38767 5.08788 4.59963 5.24416 4.75591C5.40044 4.91219 5.6124 4.99999 5.83342 4.99999ZM14.1667 10.8333C14.3878 10.8333 14.5997 10.7455 14.756 10.5892C14.9123 10.433 15.0001 10.221 15.0001 9.99999C15.0001 9.77897 14.9123 9.56701 14.756 9.41073C14.5997 9.25445 14.3878 9.16665 14.1667 9.16665C13.9457 9.16665 13.7338 9.25445 13.5775 9.41073C13.4212 9.56701 13.3334 9.77897 13.3334 9.99999C13.3334 10.221 13.4212 10.433 13.5775 10.5892C13.7338 10.7455 13.9457 10.8333 14.1667 10.8333ZM9.16675 16.6667C9.38776 16.6667 9.59972 16.5789 9.756 16.4226C9.91228 16.2663 10.0001 16.0543 10.0001 15.8333C10.0001 15.6123 9.91228 15.4003 9.756 15.2441C9.59972 15.0878 9.38776 15 9.16675 15C8.94573 15 8.73377 15.0878 8.57749 15.2441C8.42121 15.4003 8.33342 15.6123 8.33342 15.8333C8.33342 16.0543 8.42121 16.2663 8.57749 16.4226C8.73377 16.5789 8.94573 16.6667 9.16675 16.6667Z"
              fill="#557EFB"
            />
          </svg>
          Filter by Spheres
        </h2>
        <div class="filter-types" v-else>
          <ul>
            <li>
              <a
                href="#"
                role="button"
                @click="spiritualActive = !spiritualActive"
              >
                <h5>Spiritual</h5>
                <div class="track" :class="{ active: spiritualActive }">
                  <div class="icon" :style="{'background': spiritualActive?'#557EFB':'#8d99a0'}">
                    <svg
                      width="30"
                      height="30"
                      viewBox="0 0 31 31"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <g clip-path="url(#clip0)">
                        <path
                          d="M15.5 31C24.0604 31 31 24.0604 31 15.5C31 6.93959 24.0604 0 15.5 0C6.93958 0 0 6.93959 0 15.5C0 24.0604 6.93958 31 15.5 31Z"
                          :fill="spiritualActive?'#557EFB':'#8d99a0'"
                        />
                        <path
                          d="M16.8567 7.25651C16.7515 7.25492 16.6501 7.29588 16.5763 7.37083L14.5993 9.3367C14.5273 9.40868 14.4613 9.48604 14.3948 9.56309C13.6595 8.95221 12.7372 8.60899 11.7788 8.60976H10.8972C10.6821 8.60976 10.5051 8.78694 10.5051 9.00196V10.5052H9.00178C8.78677 10.5052 8.61 10.682 8.61 10.897V11.7786C8.61009 12.0739 8.65061 12.3671 8.71351 12.6555C8.44867 12.8217 8.19774 13.01 7.97677 13.2314L7.37108 13.8371C7.21908 13.9891 7.21908 14.2391 7.37108 14.3911L9.36244 16.3828C9.43268 16.4531 9.50809 16.5171 9.58294 16.5816C8.95981 17.3204 8.60924 18.252 8.61 19.2211V20.1026C8.61003 20.3176 8.78677 20.4944 9.00178 20.4944H10.5051V21.9977C10.5051 22.2127 10.6822 22.3898 10.8973 22.3898H11.7788C12.0863 22.3898 12.3913 22.3462 12.6911 22.2781C12.8551 22.5379 13.0404 22.7844 13.2579 23.0017L13.8655 23.6252C13.9385 23.7001 14.0384 23.7426 14.143 23.7434H14.1455C14.249 23.7434 14.3486 23.7024 14.422 23.6294L16.4 21.6629V21.6627C16.4718 21.5906 16.5378 21.5134 16.6041 21.4363C17.3395 22.0475 18.2617 22.3907 19.2206 22.3899H20.102C20.3171 22.3899 20.4941 22.2128 20.4941 21.9977V20.4945H21.9975C22.2125 20.4945 22.3893 20.3177 22.3893 20.1027V19.2208C22.3892 18.9255 22.3487 18.6325 22.2858 18.3442C22.5506 18.178 22.8012 17.9899 23.0222 17.7685L23.6282 17.1625C23.7802 17.0105 23.7802 16.7603 23.6282 16.6082L21.6368 14.6165C21.5666 14.5464 21.4911 14.4825 21.4164 14.418C22.0395 13.6792 22.3901 12.7477 22.3893 11.7787V10.8971C22.3893 10.6821 22.2125 10.5053 21.9975 10.5053H20.4941V9.00194C20.4941 8.78692 20.3171 8.60983 20.102 8.60983H19.2206C18.913 8.60986 18.6076 8.65337 18.3079 8.72155C18.144 8.46208 17.9595 8.21605 17.7424 7.99895L17.7405 7.99768L17.1328 7.37431C17.06 7.29954 16.9601 7.25732 16.8557 7.25635L16.8567 7.25651ZM16.8488 8.20525L17.1829 8.54787L17.1858 8.55072C18.4848 9.85272 18.4847 11.9568 17.1858 13.2589L16.8057 13.6389C16.5317 13.446 16.2212 13.317 15.8911 13.2591V12.7229C15.8911 11.7705 15.554 10.8533 14.9499 10.1199C15.015 10.0417 15.0805 9.96392 15.1524 9.89192V9.89165L16.8488 8.20525ZM11.2886 9.39373H11.7781C13.6174 9.39563 15.1053 10.8837 15.1073 12.723V13.2616C14.2635 13.4116 13.5854 14.0165 13.3318 14.8326C12.1046 14.3109 11.292 13.1198 11.2886 11.7786V11.7783V9.39373ZM19.2206 9.39373H19.7104V10.5052H19.2206C19.1197 10.5053 19.019 10.5132 18.9185 10.5206C18.8848 10.1539 18.8 9.79533 18.6699 9.45102C18.8523 9.42046 19.0355 9.39378 19.2206 9.39373ZM9.39357 11.2888H10.5047V11.7786C10.5047 11.8708 10.512 11.9612 10.5182 12.0518C10.1504 12.0835 9.79042 12.1665 9.44468 12.2955C9.41779 12.1242 9.39369 11.9521 9.39361 11.7786L9.39357 11.2888ZM19.2206 11.2888H21.6054V11.7786C21.6035 13.6178 20.1157 15.1056 18.2765 15.1078H17.7399C17.682 14.7777 17.5535 14.467 17.3605 14.1929L17.7399 13.8135V13.8132C18.4155 13.1413 18.8258 12.2534 18.9168 11.3072C19.0178 11.2979 19.1188 11.289 19.2202 11.2889L19.2206 11.2888ZM10.6522 12.8262C10.9053 13.7741 11.4903 14.5876 12.2921 15.1452C11.5055 15.2281 10.7596 15.5294 10.143 16.0297C10.0653 15.9651 9.98805 15.8999 9.91638 15.8285L8.20216 14.1139L8.531 13.785C9.0969 13.2148 9.85225 12.8789 10.6518 12.8262H10.6522ZM15.5052 13.9926C15.5586 13.9932 15.6117 13.9969 15.6646 14.0032C15.8055 14.0201 15.9436 14.0567 16.0747 14.111C16.5993 14.3282 17.0028 14.8248 17.0028 15.4997C17.0009 16.3309 16.3307 17.0018 15.4995 17.003C14.8247 17.003 14.3277 16.5998 14.1105 16.0752C13.8932 15.5506 13.9593 14.9141 14.4365 14.437C14.7496 14.1239 15.1314 13.9877 15.5052 13.9926ZM20.8559 14.9699H20.8559C20.9337 15.0346 21.0109 15.0997 21.0826 15.1711L22.7972 16.8854L22.468 17.2145C21.902 17.7846 21.1467 18.1207 20.3471 18.1734C20.0941 17.2256 19.5089 16.4121 18.7073 15.8544C19.4939 15.7715 20.2396 15.4702 20.8562 14.9699H20.8559ZM12.7225 15.8918H12.7226H13.2588C13.3166 16.2219 13.4456 16.5324 13.6385 16.8064L13.2591 17.1861C12.5833 17.858 12.1728 18.7458 12.0818 19.6921C11.9808 19.7015 11.8795 19.7103 11.7781 19.7105H9.39357V19.221C9.39547 17.3819 10.8834 15.8941 12.7225 15.8918V15.8918ZM17.6672 16.1669C18.8944 16.6887 19.7071 17.8797 19.7104 19.2211V21.6059H19.2205C17.3813 21.604 15.8934 20.1159 15.8913 18.2766V17.7381C16.7352 17.5882 17.4136 16.9831 17.6672 16.1669ZM14.1927 17.3607C14.4668 17.5536 14.7775 17.6825 15.1077 17.7403V18.2766C15.1077 19.2289 15.4446 20.1459 16.0485 20.8793C15.9836 20.9576 15.9181 21.0355 15.8464 21.1076L14.1502 22.7944L13.8144 22.4498C13.8144 22.4501 13.8144 22.4491 13.8144 22.4495V22.4492V22.4489C12.5133 21.1478 12.5133 19.042 13.8144 17.7409L14.1927 17.3607ZM21.5543 18.7038C21.5812 18.8752 21.6053 19.0474 21.6054 19.2211V19.7105H20.4942V19.2211C20.4942 19.1287 20.487 19.0382 20.4808 18.9475C20.8487 18.9159 21.2084 18.8328 21.5542 18.7038H21.5543ZM12.0805 20.479C12.1142 20.8456 12.1986 21.2042 12.3287 21.5485C12.1464 21.5791 11.9634 21.6059 11.7784 21.6059H11.2887V20.4944H11.7784C11.8792 20.4943 11.9799 20.4863 12.0805 20.4789V20.479Z"
                          fill="white"
                        />
                      </g>
                      <defs>
                        <clipPath id="clip0">
                          <rect width="31" height="31" fill="white" />
                        </clipPath>
                      </defs>
                    </svg>
                  </div>
                </div>
              </a>
            </li>
            <li>
              <a href="#" role="button" @click="healthActive = !healthActive" :style="{'background': healthActive?'#FF8C7D':'#8d99a0'}">
                <h5>Health</h5>
                <div class="track " :class="{ active: healthActive }">
                  <div class="icon" >
                    <svg
                      width="30"
                      height="30"
                      viewBox="0 0 31 31"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M15.5 31C24.0604 31 31 24.0604 31 15.5C31 6.93959 24.0604 0 15.5 0C6.93959 0 0 6.93959 0 15.5C0 24.0604 6.93959 31 15.5 31Z"
                        
                        :fill="healthActive?'#FF8C7D':'#8d99a0'"
                      />
                      <path
                        d="M11.7162 7.92719C10.4067 7.92719 9.20444 8.45088 8.32705 9.40248C7.46007 10.3429 6.98145 11.6288 6.98145 13.0251C6.98145 14.4615 7.51467 15.7743 8.66935 17.1676C9.70241 18.4141 11.1924 19.6847 12.92 21.1569C12.9209 21.1576 12.9219 21.1584 12.9228 21.1592C13.512 21.6613 14.1797 22.2309 14.8728 22.8369C15.0461 22.9887 15.2685 23.0719 15.4993 23.0719C15.7299 23.0719 15.9525 22.9885 16.1257 22.8369C16.8203 22.2295 17.4889 21.6594 18.0792 21.1565C19.8065 19.6845 21.2964 18.4138 22.3295 17.1672C23.4842 15.774 24.0177 14.4615 24.0177 13.0251C24.0177 11.6288 23.5391 10.3429 22.6721 9.40248C21.7947 8.45088 20.5924 7.92719 19.283 7.92719C18.3049 7.92719 17.4114 8.23579 16.6224 8.846C16.2241 9.15401 15.8629 9.5312 15.544 9.97193C15.5389 9.97898 15.5322 9.9847 15.5244 9.98865C15.5166 9.99261 15.508 9.99467 15.4992 9.99467C15.4905 9.99467 15.4819 9.99261 15.4741 9.98865C15.4663 9.9847 15.4596 9.97898 15.4544 9.97193C15.1357 9.5312 14.7746 9.15401 14.3764 8.846C13.5874 8.2358 12.694 7.92719 11.7159 7.92719H11.7162ZM11.7162 8.82085C12.4901 8.82085 13.203 9.06799 13.8297 9.5526C14.3885 9.98478 14.7753 10.5286 15.0024 10.9092C15.1084 11.0867 15.2932 11.1918 15.4996 11.1918C15.7059 11.1918 15.8908 11.0867 15.9967 10.9092C16.2239 10.5286 16.6107 9.98478 17.1694 9.5526C17.7961 9.068 18.509 8.82085 19.2829 8.82085C20.338 8.82085 21.3099 9.24284 22.0154 10.0081C22.7314 10.7848 23.1244 11.8567 23.1244 13.0251C23.1244 14.2585 22.6634 15.3648 21.642 16.5974C20.6546 17.7889 19.192 19.0344 17.5003 20.4762C16.9077 20.9811 16.2362 21.5534 15.5345 22.1645C15.5244 22.1734 15.5114 22.1783 15.498 22.1783C15.4845 22.1783 15.4716 22.1734 15.4614 22.1645C14.7649 21.5555 14.096 20.9849 13.5051 20.4813L13.5019 20.479C13.501 20.4782 13.5 20.4774 13.4991 20.4766C11.8073 19.0348 10.3443 17.7889 9.35694 16.5974C8.33542 15.3649 7.87457 14.2585 7.87457 13.0251C7.87457 11.8567 8.26757 10.7848 8.98362 10.0081C9.68923 9.24287 10.6609 8.82086 11.7161 8.82086L11.7162 8.82085Z"
                        fill="white"
                      />
                    </svg>
                  </div>
                </div>
              </a>
            </li>
            <li>
              <a href="#" role="button" @click="financeActive = !financeActive">
                <h5>Finance</h5>
                <div class="track " :class="{ active: financeActive }">
                  <div class="icon" :style="{'background': financeActive?'#65EA82':'#8D99A0'}">
                    <svg
                      width="30"
                      height="30"
                      viewBox="0 0 31 31"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <g clip-path="url(#clip0)">
                        <path
                          d="M15.5 31C24.0604 31 31 24.0604 31 15.5C31 6.93959 24.0604 0 15.5 0C6.93959 0 0 6.93959 0 15.5C0 24.0604 6.93959 31 15.5 31Z"
                          :fill="financeActive?'#65EA82':'#8D99A0'"
                        />
                        <path
                          d="M11.226 8.40784C10.3024 8.41189 9.55279 9.15543 9.53763 10.0794H9.35966C8.42659 10.0794 7.6684 10.8335 7.66431 11.7666C7.66431 11.7666 7.66431 11.7667 7.66431 11.7668V20.8925C7.66431 20.8926 7.66431 20.8926 7.66431 20.8927C7.66839 21.8257 8.42237 22.5878 9.35948 22.5919H19.7737C20.6973 22.5878 21.4469 21.8443 21.4621 20.9204H21.64C22.5731 20.9204 23.3313 20.1663 23.3354 19.2332C23.3354 19.2331 23.3354 19.233 23.3354 19.233V10.1071C23.3354 10.107 23.3354 10.107 23.3354 10.1069C23.3313 9.17008 22.5772 8.41193 21.6402 8.40784H11.226V8.40784ZM11.226 9.29915H11.2265H21.6403C22.0841 9.3031 22.4406 9.66333 22.4444 10.1075V12.029L21.4652 13.291V11.7667C21.4652 10.8335 20.7069 10.0794 19.7738 10.0794H10.4289C10.4437 9.64859 10.7918 9.30302 11.2261 9.29915H11.226ZM9.35948 10.9707H19.7737C20.2138 10.9707 20.5738 11.323 20.5738 11.7667V14.0009C20.5183 14.0109 20.4625 14.0194 20.4105 14.0194H18.114C16.8385 14.0194 15.8019 15.0561 15.8019 16.3316C15.8019 17.6071 16.8384 18.6438 18.1139 18.6478H20.4063C20.4072 18.6479 20.4081 18.6479 20.4089 18.6478C20.4641 18.6448 20.5171 18.6385 20.5697 18.6326L20.5736 20.8926C20.5736 21.3365 20.2173 21.6966 19.7735 21.7005H9.35967H9.35921C8.91553 21.6966 8.55911 21.3365 8.55516 20.8925V11.7672V11.7667C8.55915 11.3269 8.91534 10.9707 9.35921 10.9707L9.35948 10.9707ZM22.4405 13.4857L22.4442 15.7622L21.2084 17.3652C21.0186 17.612 20.7219 17.7567 20.4099 17.7605H18.1143H18.1139C17.3277 17.7565 16.693 17.1216 16.693 16.3356C16.693 15.5495 17.3277 14.9147 18.1139 14.9107H20.4063C20.6876 14.9107 20.9652 14.8496 21.2186 14.7271L21.219 14.7269C21.4886 14.6002 21.725 14.4085 21.9085 14.172V14.1719L22.4405 13.4857ZM18.0504 15.8899C17.8055 15.8899 17.6048 16.0907 17.6048 16.3356C17.6048 16.5805 17.8055 16.7812 18.0504 16.7812H19.0055C19.2504 16.7812 19.4512 16.5805 19.4512 16.3356C19.4512 16.0907 19.2504 15.8899 19.0055 15.8899H18.0504ZM22.4443 17.2191V19.233C22.4402 19.6728 22.0841 20.029 21.6402 20.029H21.4651V18.3166C21.6315 18.2012 21.7833 18.0619 21.9118 17.9061C21.9121 17.9057 21.9124 17.9054 21.9127 17.905L22.4443 17.2191Z"
                          fill="white"
                        />
                      </g>
                      <defs>
                        <clipPath id="clip0">
                          <rect width="31" height="31" fill="white" />
                        </clipPath>
                      </defs>
                    </svg>
                  </div>
                </div>
              </a>
            </li>
            <li>
              <a
                href="#"
                role="button"
                @click="educationActive = !educationActive"
              >
                <h5>Education</h5>
                <div class="track " :class="{ active: educationActive }">
                  <div class="icon">
                    <svg
                      width="30"
                      height="30"
                      viewBox="0 0 31 31"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M15.5 31C24.0604 31 31 24.0604 31 15.5C31 6.93959 24.0604 0 15.5 0C6.93959 0 0 6.93959 0 15.5C0 24.0604 6.93959 31 15.5 31Z"
                        
                          :fill="educationActive?'#8D99A0':'#F6F28B'"
                      />
                      <path
                        d="M10.1106 21.1949C9.85899 21.1949 9.65503 20.9909 9.65503 20.7393V10.089C9.65503 9.05265 10.4982 8.20953 11.5345 8.20953H20.8885C21.1401 8.20953 21.344 8.41354 21.344 8.66516V19.1446C21.344 19.3962 21.1401 19.6002 20.8885 19.6002C20.6368 19.6002 20.4328 19.3962 20.4328 19.1446V9.12079H11.5345C11.0006 9.12079 10.5663 9.55512 10.5663 10.089V20.7393C10.5663 20.9909 10.3623 21.1949 10.1106 21.1949V21.1949Z"
                        fill="white"
                      />
                      <path
                        d="M20.8885 22.7901H11.7054C10.5748 22.7901 9.65503 21.8703 9.65503 20.7398C9.65503 19.6092 10.5748 18.6895 11.7054 18.6895H20.8885C21.1401 18.6895 21.344 18.8935 21.344 19.1451C21.344 19.3967 21.1401 19.6007 20.8885 19.6007H11.7054C11.0773 19.6007 10.5663 20.1117 10.5663 20.7398C10.5663 21.3679 11.0773 21.8788 11.7054 21.8788H20.8885C21.1401 21.8788 21.344 22.0828 21.344 22.3345C21.344 22.5861 21.1401 22.7901 20.8885 22.7901V22.7901Z"
                        fill="white"
                      />
                      <path
                        d="M20.8885 21.1955H11.7054C11.4537 21.1955 11.2498 20.9915 11.2498 20.7399C11.2498 20.4882 11.4537 20.2842 11.7054 20.2842H20.8885C21.1401 20.2842 21.344 20.4882 21.344 20.7399C21.344 20.9915 21.1401 21.1955 20.8885 21.1955Z"
                        fill="white"
                      />
                      <path
                        d="M12.1609 19.6002C11.9093 19.6002 11.7053 19.3962 11.7053 19.1446V8.66516C11.7053 8.41354 11.9093 8.20953 12.1609 8.20953C12.4126 8.20953 12.6166 8.41354 12.6166 8.66516V19.1446C12.6166 19.3962 12.4126 19.6002 12.1609 19.6002Z"
                        fill="white"
                      />
                    </svg>
                  </div>
                </div>
              </a>
            </li>
          </ul>
          <h3 @click="showFilter = !showFilter">
            Hide filter
            <svg
              width="20"
              height="20"
              viewBox="0 0 20 20"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M9.75576 14.7559C10.0812 14.4305 10.0812 13.9028 9.75576 13.5774L6.17835 10L9.75576 6.42259C10.0812 6.09715 10.0812 5.56951 9.75576 5.24408C9.43032 4.91864 8.90269 4.91864 8.57725 5.24408L4.41058 9.41074C4.08514 9.73618 4.08514 10.2638 4.41058 10.5893L8.57725 14.7559C8.90269 15.0814 9.43032 15.0814 9.75576 14.7559Z"
                fill="#557EFB"
              />
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M15.5893 14.7559C15.9147 14.4305 15.9147 13.9028 15.5893 13.5774L12.0118 10L15.5893 6.42259C15.9147 6.09715 15.9147 5.56951 15.5893 5.24408C15.2638 4.91864 14.7362 4.91864 14.4107 5.24408L10.2441 9.41074C9.91864 9.73618 9.91864 10.2638 10.2441 10.5893L14.4107 14.7559C14.7362 15.0814 15.2638 15.0814 15.5893 14.7559Z"
                fill="#557EFB"
              />
            </svg>
          </h3>
        </div>
      </transition>
      <div class="search">
        <input type="text" class="searchi-input" placeholder="Search" />
        <svg
          width="16"
          height="17"
          viewBox="0 0 16 17"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M7.3335 3.16668C4.75617 3.16668 2.66683 5.25601 2.66683 7.83334C2.66683 10.4107 4.75617 12.5 7.3335 12.5C9.91083 12.5 12.0002 10.4107 12.0002 7.83334C12.0002 5.25601 9.91083 3.16668 7.3335 3.16668ZM1.3335 7.83334C1.3335 4.51963 4.01979 1.83334 7.3335 1.83334C10.6472 1.83334 13.3335 4.51963 13.3335 7.83334C13.3335 11.1471 10.6472 13.8333 7.3335 13.8333C4.01979 13.8333 1.3335 11.1471 1.3335 7.83334Z"
            fill="#B3C2CB"
          />
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M10.6284 11.1286C10.8887 10.8682 11.3108 10.8682 11.5712 11.1286L14.4712 14.0286C14.7315 14.2889 14.7315 14.711 14.4712 14.9714C14.2108 15.2317 13.7887 15.2317 13.5284 14.9714L10.6284 12.0714C10.368 11.811 10.368 11.3889 10.6284 11.1286Z"
            fill="#B3C2CB"
          />
        </svg>
      </div>
    </div>
    <Tracked :cards="tracked" @showHelpPane="showHelpModel" />
    <Deck :cards="deck" @showHelpPane="showHelpModel"></Deck>
    <!--        Stationed-->
    <Stationed :cards="stationed" />
    <!--        <Conductor/>-->
   
  </div>
</template>

<script>
import Tracked from "@/components/jab/Tracked";
import Help from "@/components/jab/Help";
import Conductor from "@/components/jab/Conductor";
import Deck from "@/components/jab/Deck";
import Stationed from "@/components/jab/Stationed";
import { mapGetters } from "vuex";
export default {
  name: "Panel.vue",
  props: ["bookSession"],

  data() {
    return {
     
      showFilter: false,
      spiritualActive: false,
      healthActive: false,
      financeActive: false,
      educationActive: false,
    };
  },
  components: {
    Tracked,
    Help,
    Conductor,
    Deck,
    Stationed,
  },
  computed: {
    ...mapGetters({
      tracked: "getTracked",
      deck: "getDeck",
      stationed: "getStationed",
    }),
  },

  methods: {
    showHelpModel() {
           this.$eventHub.$emit('showHelpModal');

    },
    closeHelp() {
      
      // this.bookSession = false
      this.$emit("closeBooking");
    },
  },
  watch: {
    bookSession(newval, oldval) {
      if (newval == true) {
        this.helpModel = true;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.main-panel {
  padding: 20px;
  padding-right: 0;
  .filter {
    padding-right: 25px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    min-height: 62px;
    .search {
      position: relative;
      input {
        background: #f3f6f9;
        border-radius: 100px;
        width: 265px;
        height: 39px;
        border: none;
        padding-left: 25px;
        &:focus {
          outline: none;
        }
      }
      ::placeholder {
        /* Chrome, Firefox, Opera, Safari 10.1+ */
        color: #b3c2cb;
        opacity: 1; /* Firefox */
      }

      :-ms-input-placeholder {
        /* Internet Explorer 10-11 */
        color: #b3c2cb;
      }

      ::-ms-input-placeholder {
        /* Microsoft Edge */
        color: #b3c2cb;
      }
      svg {
        position: absolute;
        left: 8px;
        top: 50%;
        transform: translateY(-50%);
      }
    }
  }
  .filter h2 {
    color: #557efb;
    font-family: "Nunito", sans-serif;
    font-weight: normal;
    font-size: 16px;
    line-height: 22px;
    cursor: pointer;
    margin-top: 10px;
    margin-bottom: 30px;
    margin-left: 2px;
  }
  .filter-types {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    min-width: 50%;
    ul {
      list-style-type: none;
      padding: 0;
      margin: 0;
      li {
        display: inline-block;
        width: 90px;
        padding: 0 10px 10px 5px;
        a {
          text-decoration: none;
          .track {
            // position: relative;
            // height: 26px;
            // width: 50px;
            // background-color: #ccc;
            border-radius: 14px;
            .icon {
            
              transition: all 0.2s ease;
              // box-shadow: 0px 0px 2px 0px #333;
            }
          }
         
        }
        h5 {
          text-transform: uppercase;
          font-weight: normal;
          font-family: "Nunito", sans-serif;
          font-size: 10px;
          line-height: 14px;
          /* identical to box height */
          letter-spacing: 0.05em;
          /* Secondary */
          color: #8d99a0;
        }
        .icon {
          height: 30px;
          width: 30px;
          // background-color: #557efb;
          border-radius: 50%;
        }
       
      }
      
    }
    h3 {
      margin-left: 10%;
      text-transform: uppercase;
      font-weight: 600;
      font-family: "Nunito", sans-serif;
      font-size: 14px;
      line-height: 19px;
      color: #557efb;
      cursor: pointer;
      margin-top: 12px;
      margin-bottom: 0;
      display: flex;
      align-content: center;
      svg {
        margin-left: 8px;
        margin-top: -2px;
      }
    }
  }
  .tracked {
    max-width: 100%;
    overflow: hidden;
  }
}
@media (max-width: 768px) {
  .filter {
    flex-direction: column;
    /*justify-content: flex-start;*/
    align-items: flex-start !important;
    margin-bottom: 10px;
  }
  .filter-types {
    flex-direction: column;
  }
  .search {
    width: 95%;
    input {
      width: 100% !important;
    }
  }
}
</style>
